import * as React from 'react';
import UserAccessService from 'services/UserAccessService';
const UserContext = React.createContext(new UserAccessService({}));
export default UserContext;
